<template>
  <div class="friend-link-container">
    <div class="operation-bar">
      <el-button type="primary" @click="handleAdd">新增友链</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="linkList"
      border
      height="calc(100vh - 180px)"
      style="width: 100%">
      <el-table-column
        prop="link_name"
        label="名称"
        width="180"
        fixed>
      </el-table-column>
      <el-table-column
        prop="link_url"
        label="链接"
        width="300">
        <template slot-scope="scope">
          <el-link type="primary" :href="scope.row.link_url" target="_blank">{{ scope.row.link_url }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述">
      </el-table-column>
      <el-table-column
        prop="link_order"
        label="排序"
        width="100">
      </el-table-column>
      <el-table-column
        prop="is_show"
        label="显示"
        width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.is_show"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      append-to-body>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="名称" prop="link_name">
          <el-input v-model="form.link_name" placeholder="请输入友链名称" ref="linkNameInput"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="link_url">
          <el-input v-model="form.link_url" placeholder="请输入友链地址"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入友链描述"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="link_order">
          <el-input-number v-model="form.link_order" :min="1" :max="99" label="排序"></el-input-number>
        </el-form-item>
        <el-form-item label="是否显示" prop="is_show">
          <el-switch
            v-model="form.is_show"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'FriendLink',
  data() {
    return {
      loading: false,
      linkList: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        link_name: '',
        link_url: '',
        description: '',
        link_order: 0,
        is_show: 1
      },
      rules: {
        link_name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        link_url: [
          { required: true, message: '请输入链接', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        console.log('开始获取友链数据')
        const response = await request.get('/api/friend-links')
        console.log('获取到的友链数据:', response)
        
        // 检查响应格式并处理数据
        if (Array.isArray(response)) {
          this.linkList = response
        } else if (response && Array.isArray(response.data)) {
          this.linkList = response.data
        } else {
          this.linkList = []
          console.warn('未获取到有效的友链数据:', response)
          this.$message.warning('未获取到友链数据')
        }
        
        console.log('处理后的友链列表:', this.linkList)
      } catch (error) {
        console.error('获取友链列表失败:', error)
        if (error.response) {
          console.error('错误响应:', error.response)
          this.$message.error(error.response.data?.message || '获取友链列表失败')
        } else if (error.request) {
          console.error('请求未收到响应')
          this.$message.error('服务器未响应，请检查网络连接')
        } else {
          console.error('请求配置错误:', error.message)
          this.$message.error('请求配置错误')
        }
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.dialogTitle = '新增友链'
      this.form = {
        id: null,
        link_name: '',
        link_url: '',
        description: '',
        link_order: this.linkList.length + 1,
        is_show: 1
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到名称输入框
        setTimeout(() => {
          this.$refs.linkNameInput && this.$refs.linkNameInput.focus()
        }, 100)
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑友链'
      this.form = { ...row }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到名称输入框
        setTimeout(() => {
          this.$refs.linkNameInput && this.$refs.linkNameInput.focus()
        }, 100)
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该友链吗？', '提示', {
          type: 'warning'
        })
        await request.delete('/api/friend-links/' + row.id)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除友链失败:', error)
          this.$message.error('删除友链失败')
        }
      }
    },
    async handleStatusChange(row) {
      try {
        await request.put('/api/friend-links/' + row.id + '/status', {
          is_show: row.is_show
        })
        this.$message.success('状态更新成功')
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('更新状态失败')
        row.is_show = row.is_show === 1 ? 0 : 1 // 恢复状态
      }
    },
    async submitForm() {
      try {
        await this.$refs.form.validate()
        if (this.form.id) {
          await request.put('/api/friend-links/' + this.form.id, this.form)
        } else {
          await request.post('/api/friend-links', this.form)
        }
        this.$message.success(this.dialogTitle + '成功')
        this.dialogVisible = false
        this.fetchData()
      } catch (error) {
        if (error !== false) {
          console.error('提交友链失败:', error)
          this.$message.error('提交友链失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.friend-link-container {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;

  .operation-bar {
    margin-bottom: 20px;
  }

  .el-table {
    margin-bottom: 20px;

    // 确保表头始终显示
    ::v-deep .el-table__header-wrapper {
      position: sticky;
      top: 0;
      z-index: 2;
    }

    // 设置表格内容区域的最大高度，允许滚动
    ::v-deep .el-table__body-wrapper {
      overflow-y: auto;
    }
  }

  // 弹窗垂直居中样式
  ::v-deep .el-dialog {
    margin-top: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

    .el-dialog__header {
      padding: 16px 20px;
      background-color: #f5f7fa;
      border-bottom: 1px solid #e4e7ed;
    }

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }

    .el-dialog__body {
      padding: 20px 20px 10px;
    }

    .el-dialog__footer {
      padding: 10px 20px 16px;
      border-top: 1px solid #f0f0f0;
    }

    .el-form {
      padding: 0;  // 重置既有的内边距，避免双重内边距
    }
  }
}
</style> 